const TimePeriod = {
    Minute: 60,
    Hour: 3600,
};

export default TimePeriod;
